import type { NotifyPort } from '@/features/messages/domain/notify'
import type { TimeOffPort, TimeOffRequest } from '../domain/timeoff'

const rejectTimeOffDept = async (
	port: TimeOffPort,
	id: string,
	actorId: string,
	actorName: string,
	note: string | null,
	notify: NotifyPort,
): Promise<TimeOffRequest> => {
	if (!note?.trim()) throw new Error('A reason is required to reject the request.')
	try {
		const request = await port.rejectDept(id, actorId, actorName, note)
		notify.success('hr.requestRejectedByDepartment')
		return request
	} catch {
		notify.error('hr.requestRejectFailed')
		throw new Error('Failed to reject request.')
	}
}

export { rejectTimeOffDept }
